module.exports = __webpack_public_path__ + "static/media/line-polos.f272d22a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/line-polos.svg
// module id = 761
// module chunks = 0